import React from 'react';
import { useRecoilValue } from 'recoil';
import * as atoms from '../atoms';
import { useCloseModal, useGraph } from '../hooks';
import BasemapView from './basemap';
import ImportModal from './import/ImportModal';
import ExportModal from './export/ExportModal';
import Lifecycle from './lifecycle/Lifecycle';
import Intro from './intro';
export default function Application() {
    var modal = useRecoilValue(atoms.modal);
    var view = useRecoilValue(atoms.view);
    var graph = useGraph();
    var closeModal = useCloseModal();
    var viewComponent = null;
    if (view === 'basemap')
        viewComponent = React.createElement(BasemapView, null);
    return (React.createElement(React.Fragment, null,
        graph === null ? React.createElement(Intro, null) : null,
        React.createElement(Lifecycle, null),
        React.createElement(ImportModal, { isOpen: modal === 'import', close: graph !== null ? closeModal : null, canClose: graph !== null }),
        React.createElement(ExportModal, { isOpen: modal === 'export', close: closeModal }),
        viewComponent));
}
